import { DropdownIndicatorProps } from 'react-select';
import { ChevronDown16 } from 'ui/icons/aurora/16px/ChevronDown16';
import { CSSProperties } from 'react';
import { colors } from 'ui/theme/colors';
import { SelectIconWrapper } from './Select.styles';
import { BaseOption } from './types';

export const SelectDropdownIndicator = (props: DropdownIndicatorProps<BaseOption>) => {
  const {
    getStyles,
    innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div {...restInnerProps} ref={ref} style={getStyles('clearIndicator', props) as CSSProperties}>
      <SelectIconWrapper>
        <ChevronDown16 color={colors.iconPrimary} />
      </SelectIconWrapper>
    </div>
  );
};
